import React, { createContext, useContext, useState, useEffect } from "react";

const AssessmentContext = createContext(null);
const STORAGE_KEY = "ws_assessments_v1";

export function AssessmentProvider({ children }) {
  const [results, setResults] = useState({}); // { slug: { answers, score, ts } }

  useEffect(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) setResults(JSON.parse(raw));
    } catch (e) { /* ignore */ }
  }, []);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(results));
    } catch (e) { /* ignore */ }
  }, [results]);

  const saveResult = (slug, payload) => {
    setResults(prev => ({ ...prev, [slug]: { ...payload, ts: Date.now() } }));
  };

  const clearResult = (slug) => {
    setResults(prev => {
      const n = { ...prev };
      delete n[slug];
      return n;
    });
  };

  const clearAll = () => setResults({});

  return (
    <AssessmentContext.Provider value={{ results, saveResult, clearResult, clearAll }}>
      {children}
    </AssessmentContext.Provider>
  );
}

export const useAssessments = () => {
  const ctx = useContext(AssessmentContext);
  if (!ctx) throw new Error("useAssessments must be used within AssessmentProvider");
  return ctx;
};
